module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add","update":"Update","edit":"Edit","unlink":"Unlink"},"da":{"add":"Tilføj","update":"Opdater","edit":"Rediger","unlink":"Fjern"}}')
  delete Component.options._Ctor
}
